
















import { Component, Prop, Vue } from 'vue-property-decorator'

@Component({
  name: 'red-packet-bags',
  components: {
  }
})
export default class RedPacketBags extends Vue {
  @Prop() item!: any[];
  @Prop(Number) activeIndex!: number;
  mounted() {
  }
  private clickHandler() {
    this.$emit('onBtnClik', this.item)
  }
}
